import { makeStyles } from '@material-ui/core';

export const useAddItemToolbarStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#F5F5F5',
  },
  button: {
    margin: '10px',
  },
}));
